import styled from 'styled-components'

const selectedColor = 'var(--button-selected-color)'
const selectedTextColor = 'var(--button-selected-text-color)'

export const Button = styled.button<{
  selected?: boolean
  colorMode?: 'dark' | 'light' | undefined
}>`
  background-color: transparent;
  padding: 8px 12px;
  border: 0;
  border-radius: 3px;
  font-size: 15px;
  text-align: center;
  color: ${(props) => (props.selected ? selectedTextColor : '#202346')};
  background-color: ${(props) => (props.selected ? selectedColor : '#fff')};
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.15);
  /* ,
    0px 0px 6px 2px rgba(100, 100, 100, 0.3); */
  &:hover {
    cursor: pointer;
    background-color: ${selectedColor};
    color: ${selectedTextColor};
  }
`
